import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Tables } from "../../../../../../../../Components";
import { PaginationComponent } from "../../../../../../../../Components/PaginationComponent/PaginationComponent";

import { bottomBoxComponentUpdate } from "../../../../../../../../Helper";
import { CommissionsHeaderData } from "./CommissionsHeaderData";

export const PSIClubCommissionsTableComponent = ({
  parentTranslationPath,
  translationPath,
  setFilter,
  filter,
  allClubTransaction,
  commissionPercentage,
}) => {
  const { t } = useTranslation(parentTranslationPath);

  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex }));
  };
  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));
  };

  useEffect(() => {
    bottomBoxComponentUpdate(
      <PaginationComponent
        pageIndex={filter.pageIndex}
        pageSize={filter.pageSize}
        totalCount={allClubTransaction.totalCount}
        onPageIndexChanged={onPageIndexChanged}
        onPageSizeChanged={onPageSizeChanged}
      />
    );
  }, [allClubTransaction, filter]);

  return (
    <div className="w-100">
      <div className="w-100 mb-2 mt-2 d-flex-v-center-h-end flex-wrap">
        <span className="fw-bold mx-2">
          {t(`${translationPath}commission-percentage`)}:{" "}
          {`${commissionPercentage || 0} %`}
        </span>
      </div>
      <div className="w-100 px-3">
        <Tables
          data={allClubTransaction?.result || []}
          headerData={CommissionsHeaderData(t, translationPath)}
          onPageIndexChanged={onPageIndexChanged}
          onPageSizeChanged={onPageSizeChanged}
          defaultActions={[]}
          itemsPerPage={filter.pageSize}
          activePage={filter.pageIndex}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          totalItems={allClubTransaction?.totalCount}
        />
      </div>
    </div>
  );
};
